import React from 'react';
import './PostSkeleton.css';

const PostSkeleton: React.FC = () => {
  return (
    <div className="post skeleton">
      <div className="post-avatar-column">
        <div className="skeleton-avatar pulse" />
      </div>
      <div className="post-content-column">
        <div className="post-header">
          <div className="skeleton-username pulse" />
          <div className="skeleton-timestamp pulse" />
        </div>
        <div className="skeleton-content">
          <div className="skeleton-line pulse" />
          <div className="skeleton-line pulse" style={{ width: '85%' }} />
          <div className="skeleton-line pulse" style={{ width: '65%' }} />
        </div>
        <div className="post-footer">
          <div className="skeleton-action pulse" />
          <div className="skeleton-action pulse" />
          <div className="skeleton-action pulse" />
        </div>
      </div>
    </div>
  );
};

export default PostSkeleton;
